<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.UploadProof.DetailedInformation')}}</div>
    </div>
    <div class="listView">

    </div>
  </div>
</template>

<script>
// import {Loadmore, Toast} from 'mint-ui'
export default {
  name: 'UploadproofDepositDetail',
  data () {
    return {
      list: []
    }
  },
  watch: {
    '$store.state.locale': function () {

    }
  },
  components: {
    // Loadmore
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    gotoDeatil () {
      this.$router.push('UploadproofDepositDetail')
    }
  }
}
</script>

<style lang="less" scoped>
/* 通用样式 */
input::placeholder {
  color: #464646;
  opacity: 1; /* 可选：设置placeholder文本的不透明度 */
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-input-placeholder {
  color: #464646;
}
.GdPage {
  position: relative;
  top: -10px;
  height: 100vh;
  overflow-y: hidden;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }

  .listView{
    margin-top: 6vw;
    border: 1px solid red;
    height: 83vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: hidden;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/workOrderMessageDetail.vue